import React from "react";

import { Select, TextInput } from "shared/ui";
import { CurrencyFormatter } from "shared/lib/currencyFormatter";
import { localizedText } from "shared/lib/localizedMap";

import { ExternalOptionItem } from "features/ModifierSets/types";

import { Hint } from "./styles";

const NOT_BOUND_OPTION = "";

interface ExternalIdFieldProps {
    value: string;
    onChange: (value: string) => void;
    // Пусто, когда набор правят не из позиции с привязкой к внешнему меню: тогда
    // идентификатор вводится руками, потому что списка вариантов взять неоткуда.
    options: ExternalOptionItem[];
    loading: boolean;
    locale: string;
    // Передаётся там, где у вариантов есть цена и её полезно видеть в списке.
    currencyFormatter?: CurrencyFormatter;
}

export const ExternalIdField = ({
    value,
    onChange,
    options,
    loading,
    locale,
    currencyFormatter,
}: ExternalIdFieldProps) => {
    if (loading) return <Hint>Загружаем варианты из внешнего меню…</Hint>;

    if (options.length === 0) {
        return <TextInput value={value} onChange={onChange} placeholder="Не задан" />;
    }

    const optionLabel = (option: ExternalOptionItem) => {
        const name = localizedText(option.name, locale);

        return option.price && currencyFormatter
            ? `${name} — ${currencyFormatter.toShow(option.price.price)}`
            : name;
    };

    return (
        <Select
            value={value}
            onChange={onChange}
            options={[
                { value: NOT_BOUND_OPTION, label: "Не привязан" },
                ...options.map((option) => ({ value: option.id, label: optionLabel(option) })),
            ]}
        />
    );
};
